import React, { Component } from "react";
import { CSSTransition } from "react-transition-group";
import raf from "raf";
import { getScrollTop } from "../../shared/utils";
import "./backTop.scss";

/* eslint no-return-assign: off */
/* eslint no-param-reassign: off */
const easeInOutCubic = (t, b, c, d) => {
  const cc = c - b;
  t /= d / 2;
  if (t < 1) {
    return cc / 2 * t * t * t + b;
  }
  return cc / 2 * ((t -= 2) * t * t + 2) + b;
};

const VISIBILITY_HEIGHT = 400;

/* eslint class-methods-use-this: off */
class BackTop extends Component {
  constructor() {
    super();
    this.scrollToTop = this.scrollToTop.bind(this);
  }

  state = {
    visible: false
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  setScrollTop(value) {
    document.body.scrollTop = value;
    document.documentElement.scrollTop = value;
  }

  scrollToTop() {
    const scrollTop = getScrollTop();
    const startTime = Date.now();
    const frameFunc = () => {
      const timestamp = Date.now();
      const time = timestamp - startTime;
      this.setScrollTop(easeInOutCubic(time, scrollTop, 0, 450));
      if (time < 450) {
        raf(frameFunc);
      }
    };
    raf(frameFunc);
  }

  handleScroll = () => {
    const scrollTop = getScrollTop();
    this.setState({
      visible: scrollTop > VISIBILITY_HEIGHT,
    });
  }

  render() {
    return (
      <CSSTransition
        in={this.state.visible}
        classNames="back-top-fade"
        timeout={{
          enter: 200,
          exit: 150
        }}
        mountOnEnter
        unmountOnExit
      >
        <button className="back-top" onClick={this.scrollToTop}>
          Back to top
        </button>
      </CSSTransition>
    )
  }
}

export default BackTop;



// WEBPACK FOOTER //
// ./src/components/BackTop/BackTop.jsx